import { useGetDealerBrandsQuery } from '@api/customer.api';
import { WarrantyBrand } from '@api/types';
import { TextCodes } from '@api/types/translation/TextCodes';
import { DropdownField, LoadingSkeleton } from '@components/common';
import { Box, SxProps } from '@mui/material';
import { t } from '@translations';
import { useState } from 'react';
import { useWarrantyClaimContext } from '../WarrantyClaim/WarrantyClaimProvider';

type WarrantyBrandSelectProps = {
  sx?: SxProps;
};

export const WarrantyBrandSelect = ({ sx }: WarrantyBrandSelectProps) => {
  const { form, setSerialNoValid, resetProductFields, isReadOnly } = useWarrantyClaimContext();
  const selectedBrand = form.watch('brand');

  const [value, setValue] = useState<WarrantyBrand>(selectedBrand);
  const { currentData: brands, isLoading: isBrandsLoading } = useGetDealerBrandsQuery();
  const options = brands?.data?.map((brand) => ({
    label: brand.label,
    value: brand.label,
  }));
  options?.push({ label: t(TextCodes.Warranty.Block.Others), value: 'Others' });

  const handleChange = (value: WarrantyBrand) => {
    form.setValue('brand', value);
    setSerialNoValid(null);
    resetProductFields();
    form.setValue('serialNo', '');
    setValue(value);
  };

  return (
    <Box sx={sx}>
      {isBrandsLoading ? (
        <LoadingSkeleton variant='rectangular' width='100%' height={44} />
      ) : (
        <DropdownField
          label={t(TextCodes.Warranty.Block.SelectBrand)}
          options={options || []}
          getValue={(value) => handleChange(value as WarrantyBrand)}
          value={value}
          readOnly={isReadOnly}
        />
      )}
    </Box>
  );
};
